module.exports = __webpack_public_path__ + "img/dafute.635d6567.png";